import axios from 'axios';
import { User} from "../model/user.model";

axios.defaults.baseURL = process.env.REACT_APP_BRAVERMAN;
 const apiUrl = process.env.REACT_APP_BRAVERMAN;


export const addUserApi = (user:User) => {
    console.log(user);
    return axios.post(`${apiUrl}User/PostUser`,user);
}

export const LoginUser = async(userEmail:string,userPassword:string)=>
 { 
    return await axios.post( `${apiUrl}User/Login?UserEmail=${encodeURIComponent(userEmail)}&UserPassword=${encodeURIComponent(userPassword)}`);
 } 



export const getUsers = async () => {
  try {
    const response = await axios.get(`${apiUrl}User/GetAll`);
    console.log("🔍 response.data:", response.data);
    return [...response.data]; 
  } catch (error: any) {
    console.error('❌ Error fetching users:', error.response || error.message || error);
    return []; 
  }
  };

  export const getUserById = async (userId: string) => {
    try {
  
      const response = await axios.get(`${apiUrl}User/GetById?id=${userId}`);
      return [response.data];
    }
    catch (error) {
      console.error('Error fetching user:', error);
      return [];
    }
  }
export const UpdateUserAPI = (newUser: User) => {
  
  const response= axios.put(`${apiUrl}User/UpdateUser`, newUser);
  return response;
}

  export const LoginWithGoogle=async(userEmail:string)=>{
    console.log(userEmail);
    return axios.post(`${apiUrl}User/LoginByGoogle?UserEmail=${encodeURIComponent(userEmail)}`);
}

export const GetAllProjectPerUser=async (userId:string)=>{
    try{
    const response= await axios.get(`${apiUrl}User/GetAllProjectPerUserAsync?userId=${userId}`);
    // console.log("📦 תגובת השרת (פרויקטים):", JSON.stringify(response.data, null, 2));
    return response.data;
    }
    catch (error) {
        console.error('Error fetching projects:', error);
      }
}
  
export const deleteUser = async (userId: string) => {
  try {
    const response = await axios.delete(`${apiUrl}User/DeleteUser?id=${userId}`);
    return response.data; // מחזיר true או false לפי מה שהשרת מחזיר
  } catch (error: any) {
    console.error('❌ שגיאה במחיקת משתמש:', error.response || error.message || error);
    throw error;
  }
};

